/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VerifyEmailConfirmRouteImport } from './routes/verify-email.confirm'
import { Route as AuthSsoRouteImport } from './routes/auth.sso'
import { Route as AuthenticatedSingleAppRouteImport } from './routes/_authenticated.single-app'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated.settings'
import { Route as AuthenticatedReloadsRouteImport } from './routes/_authenticated.reloads'
import { Route as AuthenticatedQvdAnalysesRouteImport } from './routes/_authenticated.qvd-analyses'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated.profile'
import { Route as AuthenticatedJobsRouteImport } from './routes/_authenticated.jobs'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated.dashboard'
import { Route as AuthenticatedConnectionsRouteImport } from './routes/_authenticated.connections'
import { Route as AuthenticatedChangelogRouteImport } from './routes/_authenticated.changelog'
import { Route as AuthenticatedCapacityRouteImport } from './routes/_authenticated.capacity'
import { Route as AuthenticatedAnalysesRouteImport } from './routes/_authenticated.analyses'
import { Route as AuthenticatedActivityRouteImport } from './routes/_authenticated.activity'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth.verify-email'
import { Route as AuthSignupRouteImport } from './routes/_auth.signup'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth.reset-password'
import { Route as AuthLoginRouteImport } from './routes/_auth.login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth.forgot-password'
import { Route as AuthenticatedSyncGroupsIndexRouteImport } from './routes/_authenticated.sync-groups.index'
import { Route as AuthenticatedSingleAppIndexRouteImport } from './routes/_authenticated.single-app.index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated.settings.index'
import { Route as AuthenticatedQvdAnalysesIndexRouteImport } from './routes/_authenticated.qvd-analyses.index'
import { Route as AuthenticatedJobsIndexRouteImport } from './routes/_authenticated.jobs.index'
import { Route as AuthenticatedCapacityIndexRouteImport } from './routes/_authenticated.capacity.index'
import { Route as AuthenticatedAnalysesIndexRouteImport } from './routes/_authenticated.analyses.index'
import { Route as AuthenticatedActivityIndexRouteImport } from './routes/_authenticated.activity.index'
import { Route as AuthenticatedSyncGroupsNewRouteImport } from './routes/_authenticated.sync-groups_.new'
import { Route as AuthenticatedSyncGroupsGroupIdRouteImport } from './routes/_authenticated.sync-groups.$groupId'
import { Route as AuthenticatedSettingsOrganizationRouteImport } from './routes/_authenticated.settings.organization'
import { Route as AuthenticatedSettingsMembersRouteImport } from './routes/_authenticated.settings.members'
import { Route as AuthenticatedSettingsAuditRouteImport } from './routes/_authenticated.settings.audit'
import { Route as AuthenticatedQvdAnalysesRunIdRouteImport } from './routes/_authenticated.qvd-analyses.$runId'
import { Route as AuthenticatedOrganizationSettingsRouteImport } from './routes/_authenticated.organization.settings'
import { Route as AuthenticatedOrganizationMembersRouteImport } from './routes/_authenticated.organization.members'
import { Route as AuthenticatedOrganizationBillingRouteImport } from './routes/_authenticated.organization.billing'
import { Route as AuthenticatedJobsIdRouteImport } from './routes/_authenticated.jobs.$id'
import { Route as AuthenticatedConnectionsNewRouteImport } from './routes/_authenticated.connections_.new'
import { Route as AuthenticatedCapacityConnectionIdRouteImport } from './routes/_authenticated.capacity.$connectionId'
import { Route as AuthenticatedAnalysesAnalysisIdRouteImport } from './routes/_authenticated.analyses.$analysisId'
import { Route as AuthenticatedSingleAppConnectionIdAppsRouteImport } from './routes/_authenticated.single-app.$connectionId.apps'
import { Route as AuthenticatedConnectionsIdEditRouteImport } from './routes/_authenticated.connections_.$id.edit'
import { Route as AuthenticatedConnectionsConnectionIdAppsRouteImport } from './routes/_authenticated.connections.$connectionId.apps'
import { Route as AuthenticatedSingleAppConnectionIdAppsAppIdRouteImport } from './routes/_authenticated.single-app.$connectionId.apps_.$appId'
import { Route as AuthenticatedQvdAnalysesRunIdCompareBaseIdRouteImport } from './routes/_authenticated.qvd-analyses.$runId_.compare.$baseId'
import { Route as AuthenticatedAnalysesAnalysisIdCompareBaseIdRouteImport } from './routes/_authenticated.analyses.$analysisId_.compare.$baseId'

const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailConfirmRoute = VerifyEmailConfirmRouteImport.update({
  id: '/verify-email/confirm',
  path: '/verify-email/confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSsoRoute = AuthSsoRouteImport.update({
  id: '/auth/sso',
  path: '/auth/sso',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSingleAppRoute = AuthenticatedSingleAppRouteImport.update({
  id: '/single-app',
  path: '/single-app',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReloadsRoute = AuthenticatedReloadsRouteImport.update({
  id: '/reloads',
  path: '/reloads',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedQvdAnalysesRoute =
  AuthenticatedQvdAnalysesRouteImport.update({
    id: '/qvd-analyses',
    path: '/qvd-analyses',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedJobsRoute = AuthenticatedJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedConnectionsRoute =
  AuthenticatedConnectionsRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChangelogRoute = AuthenticatedChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCapacityRoute = AuthenticatedCapacityRouteImport.update({
  id: '/capacity',
  path: '/capacity',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAnalysesRoute = AuthenticatedAnalysesRouteImport.update({
  id: '/analyses',
  path: '/analyses',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedActivityRoute = AuthenticatedActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedSyncGroupsIndexRoute =
  AuthenticatedSyncGroupsIndexRouteImport.update({
    id: '/sync-groups/',
    path: '/sync-groups/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSingleAppIndexRoute =
  AuthenticatedSingleAppIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSingleAppRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedQvdAnalysesIndexRoute =
  AuthenticatedQvdAnalysesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedQvdAnalysesRoute,
  } as any)
const AuthenticatedJobsIndexRoute = AuthenticatedJobsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedJobsRoute,
} as any)
const AuthenticatedCapacityIndexRoute =
  AuthenticatedCapacityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCapacityRoute,
  } as any)
const AuthenticatedAnalysesIndexRoute =
  AuthenticatedAnalysesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAnalysesRoute,
  } as any)
const AuthenticatedActivityIndexRoute =
  AuthenticatedActivityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedActivityRoute,
  } as any)
const AuthenticatedSyncGroupsNewRoute =
  AuthenticatedSyncGroupsNewRouteImport.update({
    id: '/sync-groups_/new',
    path: '/sync-groups/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSyncGroupsGroupIdRoute =
  AuthenticatedSyncGroupsGroupIdRouteImport.update({
    id: '/sync-groups/$groupId',
    path: '/sync-groups/$groupId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsOrganizationRoute =
  AuthenticatedSettingsOrganizationRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsMembersRoute =
  AuthenticatedSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsAuditRoute =
  AuthenticatedSettingsAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedQvdAnalysesRunIdRoute =
  AuthenticatedQvdAnalysesRunIdRouteImport.update({
    id: '/$runId',
    path: '/$runId',
    getParentRoute: () => AuthenticatedQvdAnalysesRoute,
  } as any)
const AuthenticatedOrganizationSettingsRoute =
  AuthenticatedOrganizationSettingsRouteImport.update({
    id: '/organization/settings',
    path: '/organization/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationMembersRoute =
  AuthenticatedOrganizationMembersRouteImport.update({
    id: '/organization/members',
    path: '/organization/members',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationBillingRoute =
  AuthenticatedOrganizationBillingRouteImport.update({
    id: '/organization/billing',
    path: '/organization/billing',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsIdRoute = AuthenticatedJobsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthenticatedJobsRoute,
} as any)
const AuthenticatedConnectionsNewRoute =
  AuthenticatedConnectionsNewRouteImport.update({
    id: '/connections_/new',
    path: '/connections/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCapacityConnectionIdRoute =
  AuthenticatedCapacityConnectionIdRouteImport.update({
    id: '/$connectionId',
    path: '/$connectionId',
    getParentRoute: () => AuthenticatedCapacityRoute,
  } as any)
const AuthenticatedAnalysesAnalysisIdRoute =
  AuthenticatedAnalysesAnalysisIdRouteImport.update({
    id: '/$analysisId',
    path: '/$analysisId',
    getParentRoute: () => AuthenticatedAnalysesRoute,
  } as any)
const AuthenticatedSingleAppConnectionIdAppsRoute =
  AuthenticatedSingleAppConnectionIdAppsRouteImport.update({
    id: '/$connectionId/apps',
    path: '/$connectionId/apps',
    getParentRoute: () => AuthenticatedSingleAppRoute,
  } as any)
const AuthenticatedConnectionsIdEditRoute =
  AuthenticatedConnectionsIdEditRouteImport.update({
    id: '/connections_/$id/edit',
    path: '/connections/$id/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedConnectionsConnectionIdAppsRoute =
  AuthenticatedConnectionsConnectionIdAppsRouteImport.update({
    id: '/$connectionId/apps',
    path: '/$connectionId/apps',
    getParentRoute: () => AuthenticatedConnectionsRoute,
  } as any)
const AuthenticatedSingleAppConnectionIdAppsAppIdRoute =
  AuthenticatedSingleAppConnectionIdAppsAppIdRouteImport.update({
    id: '/$connectionId/apps_/$appId',
    path: '/$connectionId/apps/$appId',
    getParentRoute: () => AuthenticatedSingleAppRoute,
  } as any)
const AuthenticatedQvdAnalysesRunIdCompareBaseIdRoute =
  AuthenticatedQvdAnalysesRunIdCompareBaseIdRouteImport.update({
    id: '/$runId_/compare/$baseId',
    path: '/$runId/compare/$baseId',
    getParentRoute: () => AuthenticatedQvdAnalysesRoute,
  } as any)
const AuthenticatedAnalysesAnalysisIdCompareBaseIdRoute =
  AuthenticatedAnalysesAnalysisIdCompareBaseIdRouteImport.update({
    id: '/$analysisId_/compare/$baseId',
    path: '/$analysisId/compare/$baseId',
    getParentRoute: () => AuthenticatedAnalysesRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/activity': typeof AuthenticatedActivityRouteWithChildren
  '/analyses': typeof AuthenticatedAnalysesRouteWithChildren
  '/capacity': typeof AuthenticatedCapacityRouteWithChildren
  '/changelog': typeof AuthenticatedChangelogRoute
  '/connections': typeof AuthenticatedConnectionsRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/jobs': typeof AuthenticatedJobsRouteWithChildren
  '/profile': typeof AuthenticatedProfileRoute
  '/qvd-analyses': typeof AuthenticatedQvdAnalysesRouteWithChildren
  '/reloads': typeof AuthenticatedReloadsRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/single-app': typeof AuthenticatedSingleAppRouteWithChildren
  '/auth/sso': typeof AuthSsoRoute
  '/verify-email/confirm': typeof VerifyEmailConfirmRoute
  '/analyses/$analysisId': typeof AuthenticatedAnalysesAnalysisIdRoute
  '/capacity/$connectionId': typeof AuthenticatedCapacityConnectionIdRoute
  '/connections/new': typeof AuthenticatedConnectionsNewRoute
  '/jobs/$id': typeof AuthenticatedJobsIdRoute
  '/organization/billing': typeof AuthenticatedOrganizationBillingRoute
  '/organization/members': typeof AuthenticatedOrganizationMembersRoute
  '/organization/settings': typeof AuthenticatedOrganizationSettingsRoute
  '/qvd-analyses/$runId': typeof AuthenticatedQvdAnalysesRunIdRoute
  '/settings/audit': typeof AuthenticatedSettingsAuditRoute
  '/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/sync-groups/$groupId': typeof AuthenticatedSyncGroupsGroupIdRoute
  '/sync-groups/new': typeof AuthenticatedSyncGroupsNewRoute
  '/activity/': typeof AuthenticatedActivityIndexRoute
  '/analyses/': typeof AuthenticatedAnalysesIndexRoute
  '/capacity/': typeof AuthenticatedCapacityIndexRoute
  '/jobs/': typeof AuthenticatedJobsIndexRoute
  '/qvd-analyses/': typeof AuthenticatedQvdAnalysesIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/single-app/': typeof AuthenticatedSingleAppIndexRoute
  '/sync-groups/': typeof AuthenticatedSyncGroupsIndexRoute
  '/connections/$connectionId/apps': typeof AuthenticatedConnectionsConnectionIdAppsRoute
  '/connections/$id/edit': typeof AuthenticatedConnectionsIdEditRoute
  '/single-app/$connectionId/apps': typeof AuthenticatedSingleAppConnectionIdAppsRoute
  '/analyses/$analysisId/compare/$baseId': typeof AuthenticatedAnalysesAnalysisIdCompareBaseIdRoute
  '/qvd-analyses/$runId/compare/$baseId': typeof AuthenticatedQvdAnalysesRunIdCompareBaseIdRoute
  '/single-app/$connectionId/apps/$appId': typeof AuthenticatedSingleAppConnectionIdAppsAppIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/changelog': typeof AuthenticatedChangelogRoute
  '/connections': typeof AuthenticatedConnectionsRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/reloads': typeof AuthenticatedReloadsRoute
  '/auth/sso': typeof AuthSsoRoute
  '/verify-email/confirm': typeof VerifyEmailConfirmRoute
  '/analyses/$analysisId': typeof AuthenticatedAnalysesAnalysisIdRoute
  '/capacity/$connectionId': typeof AuthenticatedCapacityConnectionIdRoute
  '/connections/new': typeof AuthenticatedConnectionsNewRoute
  '/jobs/$id': typeof AuthenticatedJobsIdRoute
  '/organization/billing': typeof AuthenticatedOrganizationBillingRoute
  '/organization/members': typeof AuthenticatedOrganizationMembersRoute
  '/organization/settings': typeof AuthenticatedOrganizationSettingsRoute
  '/qvd-analyses/$runId': typeof AuthenticatedQvdAnalysesRunIdRoute
  '/settings/audit': typeof AuthenticatedSettingsAuditRoute
  '/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/sync-groups/$groupId': typeof AuthenticatedSyncGroupsGroupIdRoute
  '/sync-groups/new': typeof AuthenticatedSyncGroupsNewRoute
  '/activity': typeof AuthenticatedActivityIndexRoute
  '/analyses': typeof AuthenticatedAnalysesIndexRoute
  '/capacity': typeof AuthenticatedCapacityIndexRoute
  '/jobs': typeof AuthenticatedJobsIndexRoute
  '/qvd-analyses': typeof AuthenticatedQvdAnalysesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/single-app': typeof AuthenticatedSingleAppIndexRoute
  '/sync-groups': typeof AuthenticatedSyncGroupsIndexRoute
  '/connections/$connectionId/apps': typeof AuthenticatedConnectionsConnectionIdAppsRoute
  '/connections/$id/edit': typeof AuthenticatedConnectionsIdEditRoute
  '/single-app/$connectionId/apps': typeof AuthenticatedSingleAppConnectionIdAppsRoute
  '/analyses/$analysisId/compare/$baseId': typeof AuthenticatedAnalysesAnalysisIdCompareBaseIdRoute
  '/qvd-analyses/$runId/compare/$baseId': typeof AuthenticatedQvdAnalysesRunIdCompareBaseIdRoute
  '/single-app/$connectionId/apps/$appId': typeof AuthenticatedSingleAppConnectionIdAppsAppIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/_authenticated/activity': typeof AuthenticatedActivityRouteWithChildren
  '/_authenticated/analyses': typeof AuthenticatedAnalysesRouteWithChildren
  '/_authenticated/capacity': typeof AuthenticatedCapacityRouteWithChildren
  '/_authenticated/changelog': typeof AuthenticatedChangelogRoute
  '/_authenticated/connections': typeof AuthenticatedConnectionsRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/jobs': typeof AuthenticatedJobsRouteWithChildren
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/qvd-analyses': typeof AuthenticatedQvdAnalysesRouteWithChildren
  '/_authenticated/reloads': typeof AuthenticatedReloadsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/single-app': typeof AuthenticatedSingleAppRouteWithChildren
  '/auth/sso': typeof AuthSsoRoute
  '/verify-email/confirm': typeof VerifyEmailConfirmRoute
  '/_authenticated/analyses/$analysisId': typeof AuthenticatedAnalysesAnalysisIdRoute
  '/_authenticated/capacity/$connectionId': typeof AuthenticatedCapacityConnectionIdRoute
  '/_authenticated/connections_/new': typeof AuthenticatedConnectionsNewRoute
  '/_authenticated/jobs/$id': typeof AuthenticatedJobsIdRoute
  '/_authenticated/organization/billing': typeof AuthenticatedOrganizationBillingRoute
  '/_authenticated/organization/members': typeof AuthenticatedOrganizationMembersRoute
  '/_authenticated/organization/settings': typeof AuthenticatedOrganizationSettingsRoute
  '/_authenticated/qvd-analyses/$runId': typeof AuthenticatedQvdAnalysesRunIdRoute
  '/_authenticated/settings/audit': typeof AuthenticatedSettingsAuditRoute
  '/_authenticated/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/_authenticated/settings/organization': typeof AuthenticatedSettingsOrganizationRoute
  '/_authenticated/sync-groups/$groupId': typeof AuthenticatedSyncGroupsGroupIdRoute
  '/_authenticated/sync-groups_/new': typeof AuthenticatedSyncGroupsNewRoute
  '/_authenticated/activity/': typeof AuthenticatedActivityIndexRoute
  '/_authenticated/analyses/': typeof AuthenticatedAnalysesIndexRoute
  '/_authenticated/capacity/': typeof AuthenticatedCapacityIndexRoute
  '/_authenticated/jobs/': typeof AuthenticatedJobsIndexRoute
  '/_authenticated/qvd-analyses/': typeof AuthenticatedQvdAnalysesIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/single-app/': typeof AuthenticatedSingleAppIndexRoute
  '/_authenticated/sync-groups/': typeof AuthenticatedSyncGroupsIndexRoute
  '/_authenticated/connections/$connectionId/apps': typeof AuthenticatedConnectionsConnectionIdAppsRoute
  '/_authenticated/connections_/$id/edit': typeof AuthenticatedConnectionsIdEditRoute
  '/_authenticated/single-app/$connectionId/apps': typeof AuthenticatedSingleAppConnectionIdAppsRoute
  '/_authenticated/analyses/$analysisId_/compare/$baseId': typeof AuthenticatedAnalysesAnalysisIdCompareBaseIdRoute
  '/_authenticated/qvd-analyses/$runId_/compare/$baseId': typeof AuthenticatedQvdAnalysesRunIdCompareBaseIdRoute
  '/_authenticated/single-app/$connectionId/apps_/$appId': typeof AuthenticatedSingleAppConnectionIdAppsAppIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invitation'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/activity'
    | '/analyses'
    | '/capacity'
    | '/changelog'
    | '/connections'
    | '/dashboard'
    | '/jobs'
    | '/profile'
    | '/qvd-analyses'
    | '/reloads'
    | '/settings'
    | '/single-app'
    | '/auth/sso'
    | '/verify-email/confirm'
    | '/analyses/$analysisId'
    | '/capacity/$connectionId'
    | '/connections/new'
    | '/jobs/$id'
    | '/organization/billing'
    | '/organization/members'
    | '/organization/settings'
    | '/qvd-analyses/$runId'
    | '/settings/audit'
    | '/settings/members'
    | '/settings/organization'
    | '/sync-groups/$groupId'
    | '/sync-groups/new'
    | '/activity/'
    | '/analyses/'
    | '/capacity/'
    | '/jobs/'
    | '/qvd-analyses/'
    | '/settings/'
    | '/single-app/'
    | '/sync-groups/'
    | '/connections/$connectionId/apps'
    | '/connections/$id/edit'
    | '/single-app/$connectionId/apps'
    | '/analyses/$analysisId/compare/$baseId'
    | '/qvd-analyses/$runId/compare/$baseId'
    | '/single-app/$connectionId/apps/$appId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invitation'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/verify-email'
    | '/changelog'
    | '/connections'
    | '/dashboard'
    | '/profile'
    | '/reloads'
    | '/auth/sso'
    | '/verify-email/confirm'
    | '/analyses/$analysisId'
    | '/capacity/$connectionId'
    | '/connections/new'
    | '/jobs/$id'
    | '/organization/billing'
    | '/organization/members'
    | '/organization/settings'
    | '/qvd-analyses/$runId'
    | '/settings/audit'
    | '/settings/members'
    | '/settings/organization'
    | '/sync-groups/$groupId'
    | '/sync-groups/new'
    | '/activity'
    | '/analyses'
    | '/capacity'
    | '/jobs'
    | '/qvd-analyses'
    | '/settings'
    | '/single-app'
    | '/sync-groups'
    | '/connections/$connectionId/apps'
    | '/connections/$id/edit'
    | '/single-app/$connectionId/apps'
    | '/analyses/$analysisId/compare/$baseId'
    | '/qvd-analyses/$runId/compare/$baseId'
    | '/single-app/$connectionId/apps/$appId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_authenticated'
    | '/accept-invitation'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_auth/signup'
    | '/_auth/verify-email'
    | '/_authenticated/activity'
    | '/_authenticated/analyses'
    | '/_authenticated/capacity'
    | '/_authenticated/changelog'
    | '/_authenticated/connections'
    | '/_authenticated/dashboard'
    | '/_authenticated/jobs'
    | '/_authenticated/profile'
    | '/_authenticated/qvd-analyses'
    | '/_authenticated/reloads'
    | '/_authenticated/settings'
    | '/_authenticated/single-app'
    | '/auth/sso'
    | '/verify-email/confirm'
    | '/_authenticated/analyses/$analysisId'
    | '/_authenticated/capacity/$connectionId'
    | '/_authenticated/connections_/new'
    | '/_authenticated/jobs/$id'
    | '/_authenticated/organization/billing'
    | '/_authenticated/organization/members'
    | '/_authenticated/organization/settings'
    | '/_authenticated/qvd-analyses/$runId'
    | '/_authenticated/settings/audit'
    | '/_authenticated/settings/members'
    | '/_authenticated/settings/organization'
    | '/_authenticated/sync-groups/$groupId'
    | '/_authenticated/sync-groups_/new'
    | '/_authenticated/activity/'
    | '/_authenticated/analyses/'
    | '/_authenticated/capacity/'
    | '/_authenticated/jobs/'
    | '/_authenticated/qvd-analyses/'
    | '/_authenticated/settings/'
    | '/_authenticated/single-app/'
    | '/_authenticated/sync-groups/'
    | '/_authenticated/connections/$connectionId/apps'
    | '/_authenticated/connections_/$id/edit'
    | '/_authenticated/single-app/$connectionId/apps'
    | '/_authenticated/analyses/$analysisId_/compare/$baseId'
    | '/_authenticated/qvd-analyses/$runId_/compare/$baseId'
    | '/_authenticated/single-app/$connectionId/apps_/$appId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  AuthSsoRoute: typeof AuthSsoRoute
  VerifyEmailConfirmRoute: typeof VerifyEmailConfirmRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email/confirm': {
      id: '/verify-email/confirm'
      path: '/verify-email/confirm'
      fullPath: '/verify-email/confirm'
      preLoaderRoute: typeof VerifyEmailConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sso': {
      id: '/auth/sso'
      path: '/auth/sso'
      fullPath: '/auth/sso'
      preLoaderRoute: typeof AuthSsoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/single-app': {
      id: '/_authenticated/single-app'
      path: '/single-app'
      fullPath: '/single-app'
      preLoaderRoute: typeof AuthenticatedSingleAppRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reloads': {
      id: '/_authenticated/reloads'
      path: '/reloads'
      fullPath: '/reloads'
      preLoaderRoute: typeof AuthenticatedReloadsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/qvd-analyses': {
      id: '/_authenticated/qvd-analyses'
      path: '/qvd-analyses'
      fullPath: '/qvd-analyses'
      preLoaderRoute: typeof AuthenticatedQvdAnalysesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs': {
      id: '/_authenticated/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof AuthenticatedJobsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/connections': {
      id: '/_authenticated/connections'
      path: '/connections'
      fullPath: '/connections'
      preLoaderRoute: typeof AuthenticatedConnectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/changelog': {
      id: '/_authenticated/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof AuthenticatedChangelogRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/capacity': {
      id: '/_authenticated/capacity'
      path: '/capacity'
      fullPath: '/capacity'
      preLoaderRoute: typeof AuthenticatedCapacityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analyses': {
      id: '/_authenticated/analyses'
      path: '/analyses'
      fullPath: '/analyses'
      preLoaderRoute: typeof AuthenticatedAnalysesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/activity': {
      id: '/_authenticated/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthenticatedActivityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/sync-groups/': {
      id: '/_authenticated/sync-groups/'
      path: '/sync-groups'
      fullPath: '/sync-groups/'
      preLoaderRoute: typeof AuthenticatedSyncGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/single-app/': {
      id: '/_authenticated/single-app/'
      path: '/'
      fullPath: '/single-app/'
      preLoaderRoute: typeof AuthenticatedSingleAppIndexRouteImport
      parentRoute: typeof AuthenticatedSingleAppRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/qvd-analyses/': {
      id: '/_authenticated/qvd-analyses/'
      path: '/'
      fullPath: '/qvd-analyses/'
      preLoaderRoute: typeof AuthenticatedQvdAnalysesIndexRouteImport
      parentRoute: typeof AuthenticatedQvdAnalysesRoute
    }
    '/_authenticated/jobs/': {
      id: '/_authenticated/jobs/'
      path: '/'
      fullPath: '/jobs/'
      preLoaderRoute: typeof AuthenticatedJobsIndexRouteImport
      parentRoute: typeof AuthenticatedJobsRoute
    }
    '/_authenticated/capacity/': {
      id: '/_authenticated/capacity/'
      path: '/'
      fullPath: '/capacity/'
      preLoaderRoute: typeof AuthenticatedCapacityIndexRouteImport
      parentRoute: typeof AuthenticatedCapacityRoute
    }
    '/_authenticated/analyses/': {
      id: '/_authenticated/analyses/'
      path: '/'
      fullPath: '/analyses/'
      preLoaderRoute: typeof AuthenticatedAnalysesIndexRouteImport
      parentRoute: typeof AuthenticatedAnalysesRoute
    }
    '/_authenticated/activity/': {
      id: '/_authenticated/activity/'
      path: '/'
      fullPath: '/activity/'
      preLoaderRoute: typeof AuthenticatedActivityIndexRouteImport
      parentRoute: typeof AuthenticatedActivityRoute
    }
    '/_authenticated/sync-groups_/new': {
      id: '/_authenticated/sync-groups_/new'
      path: '/sync-groups/new'
      fullPath: '/sync-groups/new'
      preLoaderRoute: typeof AuthenticatedSyncGroupsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sync-groups/$groupId': {
      id: '/_authenticated/sync-groups/$groupId'
      path: '/sync-groups/$groupId'
      fullPath: '/sync-groups/$groupId'
      preLoaderRoute: typeof AuthenticatedSyncGroupsGroupIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/organization': {
      id: '/_authenticated/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof AuthenticatedSettingsOrganizationRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/members': {
      id: '/_authenticated/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AuthenticatedSettingsMembersRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/audit': {
      id: '/_authenticated/settings/audit'
      path: '/audit'
      fullPath: '/settings/audit'
      preLoaderRoute: typeof AuthenticatedSettingsAuditRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/qvd-analyses/$runId': {
      id: '/_authenticated/qvd-analyses/$runId'
      path: '/$runId'
      fullPath: '/qvd-analyses/$runId'
      preLoaderRoute: typeof AuthenticatedQvdAnalysesRunIdRouteImport
      parentRoute: typeof AuthenticatedQvdAnalysesRoute
    }
    '/_authenticated/organization/settings': {
      id: '/_authenticated/organization/settings'
      path: '/organization/settings'
      fullPath: '/organization/settings'
      preLoaderRoute: typeof AuthenticatedOrganizationSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organization/members': {
      id: '/_authenticated/organization/members'
      path: '/organization/members'
      fullPath: '/organization/members'
      preLoaderRoute: typeof AuthenticatedOrganizationMembersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organization/billing': {
      id: '/_authenticated/organization/billing'
      path: '/organization/billing'
      fullPath: '/organization/billing'
      preLoaderRoute: typeof AuthenticatedOrganizationBillingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/jobs/$id': {
      id: '/_authenticated/jobs/$id'
      path: '/$id'
      fullPath: '/jobs/$id'
      preLoaderRoute: typeof AuthenticatedJobsIdRouteImport
      parentRoute: typeof AuthenticatedJobsRoute
    }
    '/_authenticated/connections_/new': {
      id: '/_authenticated/connections_/new'
      path: '/connections/new'
      fullPath: '/connections/new'
      preLoaderRoute: typeof AuthenticatedConnectionsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/capacity/$connectionId': {
      id: '/_authenticated/capacity/$connectionId'
      path: '/$connectionId'
      fullPath: '/capacity/$connectionId'
      preLoaderRoute: typeof AuthenticatedCapacityConnectionIdRouteImport
      parentRoute: typeof AuthenticatedCapacityRoute
    }
    '/_authenticated/analyses/$analysisId': {
      id: '/_authenticated/analyses/$analysisId'
      path: '/$analysisId'
      fullPath: '/analyses/$analysisId'
      preLoaderRoute: typeof AuthenticatedAnalysesAnalysisIdRouteImport
      parentRoute: typeof AuthenticatedAnalysesRoute
    }
    '/_authenticated/single-app/$connectionId/apps': {
      id: '/_authenticated/single-app/$connectionId/apps'
      path: '/$connectionId/apps'
      fullPath: '/single-app/$connectionId/apps'
      preLoaderRoute: typeof AuthenticatedSingleAppConnectionIdAppsRouteImport
      parentRoute: typeof AuthenticatedSingleAppRoute
    }
    '/_authenticated/connections_/$id/edit': {
      id: '/_authenticated/connections_/$id/edit'
      path: '/connections/$id/edit'
      fullPath: '/connections/$id/edit'
      preLoaderRoute: typeof AuthenticatedConnectionsIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/connections/$connectionId/apps': {
      id: '/_authenticated/connections/$connectionId/apps'
      path: '/$connectionId/apps'
      fullPath: '/connections/$connectionId/apps'
      preLoaderRoute: typeof AuthenticatedConnectionsConnectionIdAppsRouteImport
      parentRoute: typeof AuthenticatedConnectionsRoute
    }
    '/_authenticated/single-app/$connectionId/apps_/$appId': {
      id: '/_authenticated/single-app/$connectionId/apps_/$appId'
      path: '/$connectionId/apps/$appId'
      fullPath: '/single-app/$connectionId/apps/$appId'
      preLoaderRoute: typeof AuthenticatedSingleAppConnectionIdAppsAppIdRouteImport
      parentRoute: typeof AuthenticatedSingleAppRoute
    }
    '/_authenticated/qvd-analyses/$runId_/compare/$baseId': {
      id: '/_authenticated/qvd-analyses/$runId_/compare/$baseId'
      path: '/$runId/compare/$baseId'
      fullPath: '/qvd-analyses/$runId/compare/$baseId'
      preLoaderRoute: typeof AuthenticatedQvdAnalysesRunIdCompareBaseIdRouteImport
      parentRoute: typeof AuthenticatedQvdAnalysesRoute
    }
    '/_authenticated/analyses/$analysisId_/compare/$baseId': {
      id: '/_authenticated/analyses/$analysisId_/compare/$baseId'
      path: '/$analysisId/compare/$baseId'
      fullPath: '/analyses/$analysisId/compare/$baseId'
      preLoaderRoute: typeof AuthenticatedAnalysesAnalysisIdCompareBaseIdRouteImport
      parentRoute: typeof AuthenticatedAnalysesRoute
    }
  }
}

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedActivityRouteChildren {
  AuthenticatedActivityIndexRoute: typeof AuthenticatedActivityIndexRoute
}

const AuthenticatedActivityRouteChildren: AuthenticatedActivityRouteChildren = {
  AuthenticatedActivityIndexRoute: AuthenticatedActivityIndexRoute,
}

const AuthenticatedActivityRouteWithChildren =
  AuthenticatedActivityRoute._addFileChildren(
    AuthenticatedActivityRouteChildren,
  )

interface AuthenticatedAnalysesRouteChildren {
  AuthenticatedAnalysesAnalysisIdRoute: typeof AuthenticatedAnalysesAnalysisIdRoute
  AuthenticatedAnalysesIndexRoute: typeof AuthenticatedAnalysesIndexRoute
  AuthenticatedAnalysesAnalysisIdCompareBaseIdRoute: typeof AuthenticatedAnalysesAnalysisIdCompareBaseIdRoute
}

const AuthenticatedAnalysesRouteChildren: AuthenticatedAnalysesRouteChildren = {
  AuthenticatedAnalysesAnalysisIdRoute: AuthenticatedAnalysesAnalysisIdRoute,
  AuthenticatedAnalysesIndexRoute: AuthenticatedAnalysesIndexRoute,
  AuthenticatedAnalysesAnalysisIdCompareBaseIdRoute:
    AuthenticatedAnalysesAnalysisIdCompareBaseIdRoute,
}

const AuthenticatedAnalysesRouteWithChildren =
  AuthenticatedAnalysesRoute._addFileChildren(
    AuthenticatedAnalysesRouteChildren,
  )

interface AuthenticatedCapacityRouteChildren {
  AuthenticatedCapacityConnectionIdRoute: typeof AuthenticatedCapacityConnectionIdRoute
  AuthenticatedCapacityIndexRoute: typeof AuthenticatedCapacityIndexRoute
}

const AuthenticatedCapacityRouteChildren: AuthenticatedCapacityRouteChildren = {
  AuthenticatedCapacityConnectionIdRoute:
    AuthenticatedCapacityConnectionIdRoute,
  AuthenticatedCapacityIndexRoute: AuthenticatedCapacityIndexRoute,
}

const AuthenticatedCapacityRouteWithChildren =
  AuthenticatedCapacityRoute._addFileChildren(
    AuthenticatedCapacityRouteChildren,
  )

interface AuthenticatedConnectionsRouteChildren {
  AuthenticatedConnectionsConnectionIdAppsRoute: typeof AuthenticatedConnectionsConnectionIdAppsRoute
}

const AuthenticatedConnectionsRouteChildren: AuthenticatedConnectionsRouteChildren =
  {
    AuthenticatedConnectionsConnectionIdAppsRoute:
      AuthenticatedConnectionsConnectionIdAppsRoute,
  }

const AuthenticatedConnectionsRouteWithChildren =
  AuthenticatedConnectionsRoute._addFileChildren(
    AuthenticatedConnectionsRouteChildren,
  )

interface AuthenticatedJobsRouteChildren {
  AuthenticatedJobsIdRoute: typeof AuthenticatedJobsIdRoute
  AuthenticatedJobsIndexRoute: typeof AuthenticatedJobsIndexRoute
}

const AuthenticatedJobsRouteChildren: AuthenticatedJobsRouteChildren = {
  AuthenticatedJobsIdRoute: AuthenticatedJobsIdRoute,
  AuthenticatedJobsIndexRoute: AuthenticatedJobsIndexRoute,
}

const AuthenticatedJobsRouteWithChildren =
  AuthenticatedJobsRoute._addFileChildren(AuthenticatedJobsRouteChildren)

interface AuthenticatedQvdAnalysesRouteChildren {
  AuthenticatedQvdAnalysesRunIdRoute: typeof AuthenticatedQvdAnalysesRunIdRoute
  AuthenticatedQvdAnalysesIndexRoute: typeof AuthenticatedQvdAnalysesIndexRoute
  AuthenticatedQvdAnalysesRunIdCompareBaseIdRoute: typeof AuthenticatedQvdAnalysesRunIdCompareBaseIdRoute
}

const AuthenticatedQvdAnalysesRouteChildren: AuthenticatedQvdAnalysesRouteChildren =
  {
    AuthenticatedQvdAnalysesRunIdRoute: AuthenticatedQvdAnalysesRunIdRoute,
    AuthenticatedQvdAnalysesIndexRoute: AuthenticatedQvdAnalysesIndexRoute,
    AuthenticatedQvdAnalysesRunIdCompareBaseIdRoute:
      AuthenticatedQvdAnalysesRunIdCompareBaseIdRoute,
  }

const AuthenticatedQvdAnalysesRouteWithChildren =
  AuthenticatedQvdAnalysesRoute._addFileChildren(
    AuthenticatedQvdAnalysesRouteChildren,
  )

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsAuditRoute: typeof AuthenticatedSettingsAuditRoute
  AuthenticatedSettingsMembersRoute: typeof AuthenticatedSettingsMembersRoute
  AuthenticatedSettingsOrganizationRoute: typeof AuthenticatedSettingsOrganizationRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsAuditRoute: AuthenticatedSettingsAuditRoute,
  AuthenticatedSettingsMembersRoute: AuthenticatedSettingsMembersRoute,
  AuthenticatedSettingsOrganizationRoute:
    AuthenticatedSettingsOrganizationRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedSingleAppRouteChildren {
  AuthenticatedSingleAppIndexRoute: typeof AuthenticatedSingleAppIndexRoute
  AuthenticatedSingleAppConnectionIdAppsRoute: typeof AuthenticatedSingleAppConnectionIdAppsRoute
  AuthenticatedSingleAppConnectionIdAppsAppIdRoute: typeof AuthenticatedSingleAppConnectionIdAppsAppIdRoute
}

const AuthenticatedSingleAppRouteChildren: AuthenticatedSingleAppRouteChildren =
  {
    AuthenticatedSingleAppIndexRoute: AuthenticatedSingleAppIndexRoute,
    AuthenticatedSingleAppConnectionIdAppsRoute:
      AuthenticatedSingleAppConnectionIdAppsRoute,
    AuthenticatedSingleAppConnectionIdAppsAppIdRoute:
      AuthenticatedSingleAppConnectionIdAppsAppIdRoute,
  }

const AuthenticatedSingleAppRouteWithChildren =
  AuthenticatedSingleAppRoute._addFileChildren(
    AuthenticatedSingleAppRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedActivityRoute: typeof AuthenticatedActivityRouteWithChildren
  AuthenticatedAnalysesRoute: typeof AuthenticatedAnalysesRouteWithChildren
  AuthenticatedCapacityRoute: typeof AuthenticatedCapacityRouteWithChildren
  AuthenticatedChangelogRoute: typeof AuthenticatedChangelogRoute
  AuthenticatedConnectionsRoute: typeof AuthenticatedConnectionsRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedJobsRoute: typeof AuthenticatedJobsRouteWithChildren
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedQvdAnalysesRoute: typeof AuthenticatedQvdAnalysesRouteWithChildren
  AuthenticatedReloadsRoute: typeof AuthenticatedReloadsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedSingleAppRoute: typeof AuthenticatedSingleAppRouteWithChildren
  AuthenticatedConnectionsNewRoute: typeof AuthenticatedConnectionsNewRoute
  AuthenticatedOrganizationBillingRoute: typeof AuthenticatedOrganizationBillingRoute
  AuthenticatedOrganizationMembersRoute: typeof AuthenticatedOrganizationMembersRoute
  AuthenticatedOrganizationSettingsRoute: typeof AuthenticatedOrganizationSettingsRoute
  AuthenticatedSyncGroupsGroupIdRoute: typeof AuthenticatedSyncGroupsGroupIdRoute
  AuthenticatedSyncGroupsNewRoute: typeof AuthenticatedSyncGroupsNewRoute
  AuthenticatedSyncGroupsIndexRoute: typeof AuthenticatedSyncGroupsIndexRoute
  AuthenticatedConnectionsIdEditRoute: typeof AuthenticatedConnectionsIdEditRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedActivityRoute: AuthenticatedActivityRouteWithChildren,
  AuthenticatedAnalysesRoute: AuthenticatedAnalysesRouteWithChildren,
  AuthenticatedCapacityRoute: AuthenticatedCapacityRouteWithChildren,
  AuthenticatedChangelogRoute: AuthenticatedChangelogRoute,
  AuthenticatedConnectionsRoute: AuthenticatedConnectionsRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedJobsRoute: AuthenticatedJobsRouteWithChildren,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedQvdAnalysesRoute: AuthenticatedQvdAnalysesRouteWithChildren,
  AuthenticatedReloadsRoute: AuthenticatedReloadsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedSingleAppRoute: AuthenticatedSingleAppRouteWithChildren,
  AuthenticatedConnectionsNewRoute: AuthenticatedConnectionsNewRoute,
  AuthenticatedOrganizationBillingRoute: AuthenticatedOrganizationBillingRoute,
  AuthenticatedOrganizationMembersRoute: AuthenticatedOrganizationMembersRoute,
  AuthenticatedOrganizationSettingsRoute:
    AuthenticatedOrganizationSettingsRoute,
  AuthenticatedSyncGroupsGroupIdRoute: AuthenticatedSyncGroupsGroupIdRoute,
  AuthenticatedSyncGroupsNewRoute: AuthenticatedSyncGroupsNewRoute,
  AuthenticatedSyncGroupsIndexRoute: AuthenticatedSyncGroupsIndexRoute,
  AuthenticatedConnectionsIdEditRoute: AuthenticatedConnectionsIdEditRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AcceptInvitationRoute: AcceptInvitationRoute,
  AuthSsoRoute: AuthSsoRoute,
  VerifyEmailConfirmRoute: VerifyEmailConfirmRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
